import SocialStream from '../../organisms/SocialStream';
import { CopyBig } from '../../atoms/Copytext';
import { useIntl } from 'react-intl';

/**
 * @param {SocialStreamProps} props
 * @returns {React.ReactElement} The rendered component
 */
const CmsSocialStream = ({ items }) => {
  const intl = useIntl();
  if (items !== undefined) {
    return <SocialStream items={items} />;
  }
  return (
    <CopyBig>
      {intl.formatMessage({
        id: 'socialStream.loading',
      })}
    </CopyBig>
  );
};

export default CmsSocialStream;
